import Green from "./Green.png";
import Grey from "./Grey.png";
import Navy from "./Navy.png";
import Orange from "./Orange.png";
import Pink from "./Pink.png";
import Purple from "./Purple.png";
import Yellow from "./Yellow.png";

const Custom = "CUSTOM";

export const backgrounds: { [key: string]: string } = {
  Custom: Custom,
  Green: Green,
  Gray: Grey,
  Orange: Orange,
  Pink: Pink,
  Purple: Purple,
  Yellow: Yellow,
  Navy: Navy,
};
